<template>

  <el-tabs type="border-card">
    <el-tab-pane label="用户指南">
      <div class="guide-container">
    <div class="logo-container">
      <img src="@/assets/logo111092.png" alt="logo image" class="logo-image">
      <label class="title-label">胎压监测系统</label>
    </div>
    <div class="button-container">
      <button type="submit" class="action-button" @click="downloadAndroidApk" >
        <img src="@/assets/logo-android.png" alt="Android" class="button-icon"> <!-- 新增图片 -->
        <span class="button-text-android">Android</span> <!-- 文字用span包裹 -->
      </button>
      <button type="submit" class="action-button" @click="downloadIOSApp">
        <img src="@/assets/logo-ios.png" alt="ios" class="button-icon"> <!-- 新增图片 -->
        <span class="button-text-ios">IOS</span> <!-- 文字用span包裹 -->
      </button>
    </div>
    <div>
      <small class="button-container">推荐使用Edge、Chrome浏览器下载Android apk</small>
      <small class="button-container">重点：车辆维修后，请务必将中继器插回车辆的OBD接口上</small>
    </div>
    <div class="custom-progress" v-show="showProgress">
      <div
          class="progress-bar"
          :style="{
    transform: `scaleX(${percentage / 100})`,
    transition: percentage > 0 ? 'transform 0.3s ease' : 'none'
  }"
      ></div>
    </div>
    <div class="video-container">
      <button type="submit" class="video-button" @click="showVideo(0)">
        <img width="40" src="@/assets/video.png">
        <span class="button-text-video">传感器安装说明</span> <!-- 文字用span包裹 -->
      </button>
      <button type="submit" class="video-button" @click="showVideo(1)">
        <img width="40" src="@/assets/video.png">
        <span class="button-text-video">app安装说明</span> <!-- 文字用span包裹-->
      </button>
      <button type="submit" class="video-button" @click="showVideo(2)">
        <img width="40" src="@/assets/video.png">
        <span class="button-text-video">app使用指南</span> <!-- 文字用span包裹 -->
      </button>
    </div>
    <div>
      <video
          ref="videoPlayer"
          controls
          width="100%"
          v-if="currentVideo !== null"
          :key="currentVideo"
      >
      <source :src="videoSrc[currentVideo]" type="video/mp4">
      </video>

    </div>
    <div>
      <p></p>
      <p></p>
      <p></p>
    </div>
  </div>
    </el-tab-pane>
<!--    <el-tab-pane label="保隆霍富">-->
<!--      <iframe-->
<!--          src="https://www.bh-sens.com/"-->
<!--      style="width:100%; height:800px; border:none;"-->
<!--      ></iframe>-->
<!--    </el-tab-pane>-->
    <el-tab-pane label="应用免责声明">
      <div class="container1">
        <div class="title1">应用免责声明</div>
        <div class="title2">中文</div>
        <div class="content1">
          本政策适用于胎压监测系统系列产品及服务。
        </div>
        <div class="content1">
          在使用胎压监测系统产品或服务前，请您务必仔细阅读并透彻理解本协议全部内容，在确认充分理解并同意后使用相关产品或服务时，
        </div>
        <div class="content1">
          即表示您已经同意我们按照本隐私政策收集,使用,存储和披露您的相关信息，以及向您提供的控制和保护措施。如您对本隐私政策有任何疑问、意见或建议，请与我们联系。
        </div>
        <div class="content2">
          <ul class="bullet-points">
            <li>使用你的摄像头用于扫描二维码</li>
            <li>使用你的蓝牙用于扫描保富胎压传感器产品</li>
            <li>在胎压异常报警时，收集你的位置以及胎压数据上报到云端</li>
            <li>注册用户收集你的注册号用于提醒胎压异常</li>
            <li>云端客服给你的注册号会给与提醒就近到主机厂4S店给与技术支持</li>
          </ul>
        </div>
      </div>
      <div class="title2">English</div>
      <div class="content1">
        This policy applies to the Tyre Pressure Monitoring System range of products and services。
      </div>
      <div class="content1">
        Before using the Tire Pressure Monitoring System products or services, please be sure to carefully read and thoroughly understand the entire contents of this Agreement,
      </div>
      <div class="content1">
        and when using the relevant products or services after confirming full understanding and agreement.By doing so, you consent to the collection, use, storage and disclosure of your information in accordance with this Privacy Policy and to the controls and protections afforded to you.
      </div>
      <div class="content1">
        If you have any questions, comments or suggestions regarding this Privacy Policy, please contact us.
      </div>
      <div class="content2">
        <ul class="bullet-points">
          <li>Use your camera for scanning QR codes</li>
          <li>Use your Bluetooth to scan for Balfour tyre pressure sensor products.</li>
          <li>Collects your location as well as tyre pressure data to report to the cloud in case of abnormal tyre pressure alarms</li>
          <li>Registered users collect your registration number to alert them of abnormal tyre pressure.</li>
          <li>The registration number given to you by the cloud customer service will give you a reminder to go to the nearest OEM 4S shop for technical support.</li>
        </ul>
      </div>
      <div class="content3">我们的运营组织</div>
      <div class="content3">单位名称：保隆霍富上海电子有限公司</div>
      <div class="content3">注册地址：上海市松江区沈砖公路5500号5幢1楼</div>
      <div>
        <label>联系方式：021-31273333 ; linxin@chinabaolong.net</label>
      </div>
    </el-tab-pane>
    <el-tab-pane label="问题反馈">
      <div>

        <div class="phone-container">
          <label class="inline">手机号</label>
          <el-input
              style="width: 100%"
            type="text"
            placeholder="请输入手机号"
            v-model="phone"
            maxlength="11"
            show-word-limit
            clearable
          >
          </el-input>
        </div>

      </div>
      <div class="content-container">
        <label class="inline">问题描述</label>
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6}"
            placeholder="请描述碰到的问题"
            v-model="feedbackContent"
            maxlength="500"
            show-word-limit
            clearable>
        </el-input>
      </div>
      <div>
        <div class="file-upload-container">
          <!-- 拖拽上传组件 -->
          <el-upload
              action="#"
              class="upload-demo"
              drag
              multiple
              :auto-upload="false"
              :on-change="handleFileChange"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept=".jpg,.jpeg,.png,.mp4"
              >
<!--            :before-upload="beforeUpload"-->

            <i class="el-icon-upload"></i>
            <div class="el-upload__text">拖拽文件到此处，或<em>点击选取</em></div>
            <div class="el-upload__tip" slot="tip">支持格式：jpg/jpeg/png（≤50MB）、mp4（≤300MB）</div>
          </el-upload>

          <!-- 文件列表展示 -->
<!--          <div v-if="fileList.length" class="file-list">-->
<!--            <div v-for="(file, index) in fileList" :key="index" class="file-item">-->
<!--              <span>{{ file.name }} ({{ formatSize(file.size) }})</span>-->
<!--              <el-button type="text" @click="handlePreview(file)">预览</el-button>-->
<!--              <el-button type="text" @click="handleRemove(index)">删除</el-button>-->
<!--            </div>-->
<!--          </div>-->

          <!-- 打包下载按钮 -->
          <div class="zip-upload-button">
            <el-button
                type="primary"
                :disabled="!isFormValid"
                :loading="uploading"
                @click="handleZipUpload"
            >
              提交
            </el-button>
          </div>
        </div>
      </div>
    </el-tab-pane>
    <div v-show="globalLoading" class="global-loading">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
    </div>
  </el-tabs>
</template>

<script>
import JSZip from 'jszip';

export default {
  name: "Guide",
  components: {
    // InstallAndHelper: GuideController,
  },
  data() {
    return {
      activeName: 'first',
      apkInfo: "",
      percentage: 0,
      customColor: '#1989fa',
      showProgress: false,
      showPlayer1: false,
      showPlayer2: false,
      showPlayer3: false,
      currentVideoUrl: "",
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      isFullscreen: false,
      phone:"",
      feedbackContent:"",
      fileList: [],
      uploading: false,
      currentVideo: null, // 当前播放的视频索引
      videoSrc: [null, null, null],
      isLoading: { 1: false, 2: false, 3: false },
      globalLoading:false,
    }
  },
  mounted() {

  },
  computed: {
    isFormValid() {
      // 如果需要兼容199等新号段
      const phoneRegex = /^1(?:3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      return (
          phoneRegex.test((this.phone || '').trim()) &&
          (this.feedbackContent || '').trim().length > 0
      );
    }
  },
  methods: {
    async downloadAndroidApk() {
      try {
        const response = await fetch('/tpa-api/test/download-apk');
        const totalBytes = +response.headers.get('Content-Length');
        const reader = response.body.getReader();

        let received = 0;
        let chunks = [];
        // this.showProgress = true;
        this.globalLoading = true;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          received += value.length;
          this.percentage = Math.round((received / totalBytes) * 100);
        }
        // this.showProgress = false;
        this.globalLoading = false;
        // 创建Blob对象并触发下载
        const blob = new Blob(chunks, { type: 'application/vnd.android.package-archive' });
        const url = URL.createObjectURL(blob);

        // 创建下载链接并触发点击
        const a = document.createElement('a');
        a.href = url;
        a.download = '胎压监测系统.apk';
        document.body.appendChild(a);
        a.click();

        // 清理
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.showProgress = false;
        }, 100);
      } catch (e) {
        console.error('APK下载失败', e);
        this.$message.error('APK下载失败: ' + e.message);
        this.showProgress = false;
      }
    },
    async downloadIOSApp(){
      window.location.href = "http://apps.apple.com/cn/app/bhsens-ble-tire-tools/id6747628202";
    },
    handleFileChange(file, fileList) {
      // 文件校验（类型+大小）
      const result = this.validateFile(file);
      console.debug("result.valid " + result.valid)
      if (!result.valid) {
        this.$message.error(result.message);
        // 过滤掉无效文件
        this.fileList = fileList.filter(item => item.uid !== file.uid);
        return;
      }
      // 校验通过时更新列表
      this.fileList = fileList;
    },
    // 修改 validateFile 方法
    validateFile(file) {
      // 确保使用原始文件对象
      const fileObj = file.raw || file;

      // 安全获取文件类型，避免 undefined
      const fileType = fileObj.type || '';
      const fileName = fileObj.name || '';

      const validTypes = ['image/jpeg', 'image/png', 'video/mp4'];
      const isImage = fileType.startsWith('image/');
      const isVideo = fileType === 'video/mp4';

      // 类型校验（添加文件名后缀作为备用校验）
      if (!validTypes.includes(fileType) &&
          !['.jpg', '.jpeg', '.png', '.mp4'].some(ext => fileName.toLowerCase().endsWith(ext))) {
        return {
          valid: false,
          message: `文件 ${fileName} 格式不支持，仅支持 JPG/PNG/MP4`
        };
      }

      // 大小校验（保持不变）
      const sizeMB = fileObj.size / 1024 / 1024;
      if (isImage && sizeMB > 50) {
        return { valid: false, message: `图片 ${fileName} 超过 50MB 限制` };
      }
      if (isVideo && sizeMB > 300) {
        return { valid: false, message: `视频 ${fileName} 超过 300MB 限制` };
      }
      return { valid: true };
    },
    handleRemove(file, fileList) {
      const fileObj = file.raw || file;

      // 安全获取文件类型，避免 undefined
      const fileType = fileObj.type || '';
      const fileName = fileObj.name || '';
      console.debug(fileType + "  " + fileName);
      this.fileList = fileList;
    },
    async handleZipUpload() {
      if (!this.isFormValid) { // 校验手机号和问题描述
        this.$message.error('手机号格式错误或问题描述不能为空');
        return;
      }
      this.uploading = true;
      let zipFile = null;
      console.log("this.fileList.length", this.fileList.length);
      if (this.fileList.length > 0) {
        try {
          const zip = new JSZip();
          const promises = this.fileList.map(file => {
            return new Promise(async (resolve, reject) => {
              const fileObj = file.raw || file;
              try {
                const content = await new Promise((readResolve, readReject) => {
                  const reader = new FileReader();
                  reader.onload = () => readResolve(reader.result);
                  reader.onerror = (e) =>
                      readReject(`文件 ${fileObj.name} 读取失败: ${e.target.error}`);
                  reader.readAsArrayBuffer(fileObj);
                });
                zip.file(fileObj.name, content, { binary: true });
                resolve();
              } catch (readError) {
                reject(readError);
              }
            });
          });

          // 使用 allSettled 确保部分失败仍继续
          const results = await Promise.allSettled(promises);
          const failed = results.filter(r => r.status === 'rejected');
          if (failed.length > 0) {
            console.error("失败文件列表：", failed);
          }

          // 生成ZIP（即使部分文件失败也继续）
          zipFile = await zip.generateAsync({ type: "blob" });
          if (!zipFile || zipFile.size === 0) {
            throw new Error("生成的ZIP文件无效");
          }
          // this.$message.success("压缩成功（部分文件可能未包含）");
        } catch (error) {
          console.error("压缩流程异常：", error);
          // this.$message.error(`压缩失败: ${error.message}`);
        }
      }
      console.log("zipFile", zipFile); // 此时可能为有效Blob或null

      const formJson = JSON.stringify({
        phone: this.phone,
        feedbackContent: this.feedbackContent,
        createTime: this.getFormattedTime() // 格式化当前时间
      });

      // 4. 创建FormData对象 [9](@ref)
      const formData = new FormData();

      // 添加JSON字段（模拟Dart的MultipartFile.fromString）
      formData.append('form', new Blob([formJson], {
        type: 'application/json'
      }));

      // 添加ZIP文件（如果有）
      if (zipFile) {
        formData.append('zipFile', zipFile,
            `feedback_${Date.now()}.zip` // 时间戳文件名
        );
      }

      try {
        const response = await fetch('https://bhsens.baolong.biz/tpa-api/feedback/submitweb', {
          method: 'POST',
          body: formData,
        });

        // 1. 检查HTTP状态码
        if (!response.ok) {
          throw new Error(`HTTP错误！状态码: ${response.status}`);
        }

        // 2. 解析JSON数据（关键！）
        const result = await response.json();
        console.log("响应数据:", result); // 调试用

        // 3. 根据业务状态码处理
        if (result.code === 200) { // 使用result而非response.data
          this.$message.success(result.msg || '提交成功');
          // 清空表单
          this.phone = '';
          this.feedbackContent = '';
          this.fileList = [];
        } else {
          this.$message.error(result.msg || '提交失败');
        }
      }
      catch (error) {
        // 4. 修正错误消息（Fetch无error.response）
        this.$message.error(`请求失败: ${error.message}`);
      }
      this.uploading = false;
    },
    getFormattedTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份+1并补零
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    showVideo(index) {
      // 停止当前播放的视频
      if (this.currentVideo !== null) {
        const prevVideoEl = this.$refs[`videoPlayer${this.currentVideo}`];
        if (prevVideoEl) {
          prevVideoEl.pause();
          prevVideoEl.currentTime = 0;
        }
      }
      this.globalLoading = true;
      this.videoLoadTimeout = setTimeout(() => {
        if (this.globalLoading) {
          // console.error("视频加载超时");
          // this.$message.error("视频加载超时，请检查网络连接");
          this.globalLoading = false;
        }
      }, 3500);
      // 重置所有视频源
      this.videoSrc = [null, null, null];
      this.isLoading = [false, false, false];

      // 设置当前视频
      this.currentVideo = index;
      this.isLoading[index] = true;

      // 动态加载视频源
      const videoUrls = [
        "https://bhsens.baolong.biz/tpa-api/test/download-video?type=install_sensor",
        "https://bhsens.baolong.biz/tpa-api/test/download-video?type=install_app",
        "https://bhsens.baolong.biz/tpa-api/test/download-video?type=use",
      ];
      // 使用$set确保响应式更新
      this.$set(this.videoSrc, index, videoUrls[index]);
    },
  }
}
</script>

<style scoped>
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  display: inline-block;
  width: 60px;
  height: 60px;
  border: 5px solid rgba(39, 157, 216, 0.3);
  border-radius: 50%;
  border-top-color: #279DD8;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #279DD8;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.file-upload-container {
  margin-top: 20px;
  margin-left: 20px;
  border-top: 1px solid #eee;
  padding: 28px;
  width: 36%;
}
.file-list {
  margin: 15px 0;
  max-height: 200px;
  overflow-y: auto;
}
.file-item {
  padding: 8px;
  border-bottom: 1px dashed #eee;
  display: flex;
  justify-content: space-between;
}
.zip-upload-button {
  text-align: right;
  margin-top: 10px;
}
.container1{
  padding-left: 20px;
}
.title1{
  font-size: clamp(2.5rem, 5vw, 3.5rem);/* 增大字体 */
  font-weight: 1000; /* 中粗体 */
  letter-spacing: 2px; /* 字间距 */
  padding-top: 20px;
  padding-bottom: 20px;
}
.title2{
  font-size: clamp(2rem, 4vw, 3rem);/* 增大字体 */
  font-weight: 500; /* 中粗体 */
  letter-spacing: 1.5px; /* 字间距 */
  padding-bottom: 10px;
}
.inline {
  display: inline-block; /* 关键修改：转换显示模式 */
  margin-right: 12px;   /* 添加标签与输入框间距 */
}
.content1{
  letter-spacing: 1.5px; /* 字间距 */
  padding-bottom: 10px;
}
.content2{
  letter-spacing: 1.5px; /* 字间距 */
  padding-bottom: 10px;
  padding-left: 30px;
}
.content3{
  font-size: clamp(1.2rem, 3vw, 1.2rem);/* 增大字体 */
  font-weight: 800;
  letter-spacing: 1.8px; /* 字间距 */
  padding-bottom: 10px;
  padding-left: 30px;
}
/* 修改.guide-container 取消固定高度 */
.guide-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 顶部对齐 */
  align-items: center;
  min-height: 100vh; /* 最小高度保证初始全屏 */
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: visible; /* 允许内容溢出 */
}

/* 新增页面滚动容器 */
.scroll-wrapper {
  width: 100%;
  overflow-y: auto; /* 启用垂直滚动 */
  max-height: 100vh; /* 初始最大高度 */
  transition: max-height 0.5s ease; /* 高度变化动画 */
}

.phone-container {
  display: flex;
  flex-direction: column;
  height: 7vh;
  width: 20%;
  padding: 20px;
  box-sizing: border-box;
}

.content-container {
  display: flex;
  flex-direction: column;
  height: 13vh;
  width: 40%;
  padding: 20px;
  box-sizing: border-box;
}

.logo-container {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  animation: slideIn 0.8s ease-out forwards;
  transform: translateY(20px);
  opacity: 0;
}

:root { font-size: calc(12px + 0.3vw); }

.logo-image {
  width: min(30vw, 220px); /* 适当减小尺寸 */
  height: min(30vw, 220px);
  margin-right: 20px; /* logo与标签间距 */
  object-fit: contain;
  transition: all 0.3s ease;
  filter: drop-shadow(0 5px 15px rgba(0, 120, 255, 0.2));
}

.logo-image:hover {
  transform: scale(1.15);   /* 轻微放大效果 */
  filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.1)); /* 添加阴影效果 */
}

.title-label {
  font-size: clamp(2.5rem, 5vw, 3.5rem);/* 增大字体 */
  font-weight: 1000; /* 中粗体 */
  color: #5f5f5f; /* 深蓝色文字 */
  letter-spacing: 2px; /* 字间距 */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  opacity: 0;
  animation: fadeIn 0.8s ease-out 0.3s forwards;
}

.button-container {
  margin-top: 20px;
  animation: bounceIn 1s ease-out 0.6s forwards;
  opacity: 0;
  transform: translateY(20px);
  display: flex;
  flex-wrap: wrap;
  gap: min(5vw, 40px);
  margin-bottom:20px;
}

.custom-progress {
  width: 18%; height: 6px;
  background: #ebeef5;
}
.progress-bar {
  height: 100%;
  transform-origin: left; /* 从左侧开始缩放 */
  background: #1989fa;
  will-change: transform;
}

.button-text-android{
  display:flex;
  align-items: center;
  color: white;
  font-size: 16px;
  font-weight: bolder;
  margin-left: 8px;
  margin-top:10px;
}

.button-text-ios{
  display:flex;
  align-items: center;
  color: white;
  font-size: 16px;
  font-weight: bolder;
  margin-left: 27px;
  margin-top:10px;
}

.video-container {
  margin-top: 30px;
  animation: bounceIn 1s ease-out 0.6s forwards;
  opacity: 0;
  transform: translateY(20px);
  display: flex;
  flex-wrap: wrap;
  gap: min(5vw, 40px);
  margin-bottom: 100px;
}

.button-text-video{
  display:flex;
  align-items: center;
  color: black;
  font-size: 16px;
  font-weight: bolder;
}

.button-text-help{
  display:flex;
  align-items: center;
  color: black;
  font-size: 16px;
  font-weight: bolder;
}

.button-icon{
  display:flex;
  align-items: center;
  height: 80px;
  width: 80px;
  margin-top:-10px
}

.action-button {
  color: #000000;
  background-color: #279DD8;
  border:0;
  padding: min(5vh, 40px) min(7vw, 50px);
  border-radius: 400px;
  box-shadow: 0 5px 15px rgba(0, 150, 255, 0.3);
  transition: all 0.3s ease;
}

.action-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 150, 255, 0.4);
}

.button-text-help, .button-text-video {
  text-align: center; /* 确保文字自身居中 */
  width: 100%; /* 撑满宽度避免偏移 */
  margin-top: 8px; /* 增加图片与文字间距 */
}

.video-button {
  color: #000000;
  background-color: transparent;
  border:0;
  flex-direction: column; /* 垂直排列子元素 */
  justify-content: center;
  align-items: center;
  padding: 1vh 1vw;
  border-radius: 0px;
  transition: all 0.3s ease;
}

.video-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 150, 255, 0.4);
}

/* 动画效果 */
@keyframes slideIn {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.8);
  }
  50% {
    transform: translateY(-10px) scale(1.05);
  }
  70% {
    transform: translateY(5px) scale(1);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 768px) {
  .video-player-container {
    padding-top: 75%; /* 4:3比例更适应手机[7](@ref) */
  }

  .scroll-wrapper {
    overscroll-behavior: contain; /* 避免滚动穿透 */
  }
}

</style>